import { defineCustomElement } from 'vue';
import autobookingForm from './widgets/autobooking-form.ce.vue';
import listingCalendar from './widgets/listing-calendar.ce.vue';
import identitiesForm from './widgets/identities-form.ce.vue';

customElements.define('autobooking-form', defineCustomElement(autobookingForm));
customElements.define('listing-calendar', defineCustomElement(listingCalendar));
customElements.define('identities-form', defineCustomElement(identitiesForm));
